// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
exports.locals = {
	"breakpointPhone": "360",
	"breakpointPhoneWide": "480",
	"breakpointPhablet": "560",
	"breakpointTabletSmall": "640",
	"breakpointTablet": "768",
	"breakpointDesktop": "1024",
	"breakpointDesktopWide": "1440"
};
module.exports = exports;
